import AddIcon from "../../../assets/svg/icono_agregar_blue.svg";
type BtnAddCompetenciesModelProps ={
    openModal: ()=> void
    disabled: boolean
  }
const BtnAddCompetenciesModel = ({openModal, disabled}:BtnAddCompetenciesModelProps) => {
  return (
    <button
        id="addPrestacion"
       onClick={openModal}  
       className={disabled === false ? "btnNuevoModeloEval" : "btnNuevoModeloEvalDisable"}
       disabled={disabled}
     >
       <div className="alineacionBotonModel">
          <img src={AddIcon} alt="Agregar Prestación" style={{height: '15.49px', width: '15.49px'}} />
        </div>
    </button> 
  )
}

export default BtnAddCompetenciesModel